import React, { useEffect, useRef, useState } from 'react';
import SearchAndAddItem from '../../components/common/TableData';
import AdminDataTable from '../../components/common/AdminDataTable';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toastEmitter } from '../../../utills/utilities';
import { API_RESPONSE } from '../../../utills/app-constant';
import { deleteCampaignById, deleteModalById, getAllAssignedEmployee, getAllCompanies } from '../../../services/api-services';
import { ROUTES } from '../../routes/url-constant';
import AccessPermissionpage from './AccessPermissionpage';
import TableHeading from '../../components/common/TableHeading';
import moment from 'moment';
import { ACTIONARROW_ICON, DELETE_ICON, EDIT_ICON, RIGHTARROW_ICON } from '../../../utills/image-constant';
import DeleteModal from '../../components/common/DeleteModal';

const ViewAssimentUser = () => {
    const DeleteModalRef = useRef()
    const [pending, setPending] = useState(false);
    const [loading, setLoading] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [searchText, setSearchText] = useState("");
    const [sortColumn, setSortColumn] = useState("id");
    const [sortDirection, setSortDirection] = useState("desc");
    const [permissionAccess, setPermissionAccess] = useState();
    const [companyList, setCompanyList] = useState([]);
    const [selectedCompanyId, setSelectedCompanyId] = useState(localStorage.getItem("ViewAssesmentCompanyId") || ""); // Store selected company
    const [totalElement, settotalElement] = useState();
    const { value } = useSelector((state) => state?.adminRole);
    const [deleteCampaignId, setDeleteCampaignId] = useState(null);
    const navigate = useNavigate();

    // Retrieve the company ID from local storage
    let viewAssComapnyId = localStorage.getItem("ViewAssesmentCompanyId");
    useEffect(() => {
        const RoleAccessFilterData =
            value && value.filter((v) => v?.moduleName === "Campaign Management");
        setPermissionAccess(RoleAccessFilterData?.[0]);
    }, [value]);

    // Fetch assigned employee data by computing the payload inline
    const getallAssignCompany = async () => {
        setPending(true);
        setLoading(true);
        const currentPayload = {
            filterByFieldName: sortColumn,
            direction: sortDirection,
            pageSize: pageSize,
            pageIndex: page,
            searchText: searchText,
            companyId: viewAssComapnyId ? viewAssComapnyId : selectedCompanyId || "",
            employeeList: []
        };
        try {
            const response = await getAllAssignedEmployee(currentPayload);
            if (response?.data?.responseCode === 404) {
                setRowData([]);
            } else if (response?.data?.responseCode === 200) {
                const res = response?.data?.responseBody?.assignList;
                setRowData(res);
                settotalElement(response?.data?.responseBody?.totalElement);
            } else {
                toastEmitter("error", response?.data?.message);
            }
        } catch (err) {
            toastEmitter("error", API_RESPONSE.MESSAGE_503);
        } finally {
            setPending(false);
            setLoading(false);
        }
    };

    // Trigger data fetch when any dependency changes
    useEffect(() => {
        getallAssignCompany();
    }, [page, pageSize, sortColumn, sortDirection, selectedCompanyId, viewAssComapnyId, searchText]);


    // Fetch the list of companies
    const getallCompany = async () => {
        setPending(true);
        try {
            const response = await getAllCompanies();
            if (response?.data?.responseCode === 404) {
                setCompanyList([]);
            } else if (response?.data?.responseCode === 200) {
                const companyOptions = response?.data?.responseBody.map((data) => ({
                    value: data?.id,
                    label: data?.companyName,
                    Status: data?.status,
                }));
                setCompanyList(companyOptions);
            } else {
                toastEmitter("error", response?.data?.message);
            }
        } catch (err) {
            toastEmitter("error", API_RESPONSE.MESSAGE_503);
        } finally {
            setPending(false);
        }
    };

    useEffect(() => {
        getallCompany();
    }, []);

    const handleModelSearchChange = (e) => {
        setSearchText(e.target.value);
    };

    const handleSelect = (event) => {
        const selectedValue = event.target.value;
        setSelectedCompanyId(selectedValue);
        if (selectedValue === "") {
            localStorage.removeItem("ViewAssesmentCompanyId");
        } else {
            localStorage.setItem("ViewAssesmentCompanyId", selectedValue);
        }
    };

    const handleClearFilter = () => {
        setSelectedCompanyId("");
        localStorage.removeItem("ViewAssesmentCompanyId");
    };

    const addButtonClick = () => {
        navigate(ROUTES.ADDASSIGNEDASSESSMENTS, {
            state: { Data: rowData },
        });
    };

    const tableCustomStyles = {
        headRow: {
            style: {
                color: "#1B2128",
                fontSize: "14px",
            },
        },
        rows: {
            style: {
                color: "#1B2128",
                fontSize: "14px",
                paddingTop: "10px",
            },
        },
    };

    const deleteButtonClick = (id) => {
        setDeleteCampaignId(id)
        DeleteModalRef.current.click();
    }



    const tblColumns = [
        {
            code: "Action",
            name: "Action",
            width: "120px",
            sortable: false,
            cell: (row) => (
                <div>
                    <button
                        className="border-0 bg-white"
                        onClick={() =>
                            navigate(ROUTES.ADDASSIGNEDASSESSMENTS, {
                                state: { pageType: "Edit", Data: row },
                            })
                        }
                    >
                        <img src={EDIT_ICON} alt="Edit" className="editicon" />
                    </button>
                    <span>
                        <button
                            className="border-0 bg-white ms-2"
                            onClick={() =>
                                navigate(ROUTES.VIEWASSIGNEDEBYCOMPNYID, {
                                    state: { Data: row },
                                })
                            }
                        >
                            <img src={ACTIONARROW_ICON} alt="Action" className="editicon" />
                        </button>
                    </span>
                    <span>
                        <button
                            className="border-0 bg-white"
                            onClick={() => deleteButtonClick(row?.id)}
                        >  <img src={DELETE_ICON} alt="View" className="editicon ms-2" />
                        </button>
                    </span>
                </div>
            ),
        },
        {
            code: "title",
            name: "Title",
            width: "200px",
            sortable: true,
            selector: (row) => (
                <div className="table-cell-content">{row?.title}</div>
            ),
        },
        {
            code: "companyName",
            name: "Company Name",
            width: "200px",
            sortable: true,
            selector: (row) => (
                <div className="table-cell-content">{row?.companyResponse?.companyName}</div>
            ),
        },
        {
            code: "modelName",
            name: "Model Name",
            width: "200px",
            sortable: true,
            selector: (row) => (
                <div className="table-cell-content">{row?.companyResponse?.modelResponse?.modelName}</div>
            ),
        },
        {
            code: "durationFromDate",
            name: "From Date",
            width: "170px",
            sortable: true,
            selector: (row) => moment(row?.durationFromDate).format("MM/DD/YYYY"),
        },
        {
            code: "totalAssignEmployee",
            name: "Total Assign Employee",
            width: "190px",
            sortable: false,
            selector: (row) => <div className="table-cell-content">{row?.totalAssignEmplyee}</div>,
        },
        {
            code: "completed",
            name: "Completed",
            width: "170px",
            sortable: false,
            selector: (row) => <div className="table-cell-content">{row?.completed}</div>
        },
        {
            code: "pending",
            name: "Pending",
            width: "170px",
            sortable: false,
            selector: (row) => <div className="table-cell-content">{row?.pending}</div>
        },
        {
            code: "notStarted",
            name: "Not Started",
            width: "170px",
            sortable: false,
            selector: (row) => <div className="table-cell-content">{row?.notStarted}</div>
        },
    ];

    const handleModalDelete = async () => {
        console.log("response------------", deleteCampaignId);
        try {
            const response = await deleteCampaignById(deleteCampaignId);
            if (response?.data?.responseCode === 200) {
                toastEmitter('success', response.data.message);
                getallAssignCompany();
            } else {
                toastEmitter('error', response.data.message || API_RESPONSE?.MESSAGE_500)
            }
        } catch (err) {

        }
    }

    return (
        <>
            {permissionAccess?.addAction === 0 &&
                permissionAccess?.updateAction === 0 &&
                permissionAccess?.viewAction === 0 ? (
                <AccessPermissionpage />
            ) : (
                <div className="modal_datatable">
                    <TableHeading firstData="Campaign Management" icon={RIGHTARROW_ICON} secondData="Campaign Setup" />
                    <div className="container-fluid">
                        <div className="caspera_admin_datatable mb-3">
                            <SearchAndAddItem
                                searchValue={searchText}
                                onSearchChange={handleModelSearchChange}
                                addButtonClick={addButtonClick}
                                data="Campaign"
                                permissionAccessbtn={permissionAccess?.addAction}
                                labelName="Select Company"
                                lableclassName="addInput-label"
                                name="companyId"
                                options={companyList}
                                className="form-control addInputText-lable"
                                handleSelect={handleSelect}
                                value={viewAssComapnyId ? viewAssComapnyId : selectedCompanyId}
                                showDropdown={true}
                                clearbtn={true}
                                handleClear={handleClearFilter}
                            />

                            <AdminDataTable
                                _tblColumns={tblColumns}
                                _rowData={rowData}
                                tableCustomStyles={tableCustomStyles}
                                pending={pending}
                                setPending={setPending}
                                _totalRows={totalElement}
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                setPage={setPage}
                                setSortColumn={setSortColumn}
                                setSortDirection={setSortDirection}
                            />
                        </div>
                    </div>
                    <DeleteModal
                        DeleteModalRef={DeleteModalRef}
                        title="Model"
                        handleDelete={handleModalDelete}
                    />
                </div>
            )}

        </>
    );
};

export default ViewAssimentUser;
